// extracted by mini-css-extract-plugin
var _1 = "DatePickerHeader_monthTitle__1ec36";
var _2 = "DatePickerHeader_root__199e4";
export { _1 as "monthTitle", _2 as "root" }
